module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 1-2b5a5bc4de84f21142a05dd61066ae32.jpg";